import DataTable from "react-data-table-component";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import ModalTambahTandaTerima from "../components/ModalTambahTandaTerima";
import TandaTerimaColumns from "../constants/TandaTerimaColumns";
import { useContext, useEffect, useState } from "react";
import { useThemeContext } from "../../../Context/ThemeContext";
import { filterSearch } from "../../../Utils/FilterItems";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { Button, Col, Row } from "reactstrap";
import { CreateButton } from "../../../CommonElements";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useTandaTerima } from "../../../Context/TandaTerimaContext";

const TandaTerimaContain = ({ selectedKurir, isKurir, onResetKurir }) => {
  const tandaTerimaAPI = useTandaTerima();
  const [tandaTerimaList, setTandaTerimaList] = useState([]);
  const [pending, setPending] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [localKurir, setLocalKurir] = useState(selectedKurir);
  const { themeContext } = useThemeContext();
  const { checkPermission } = useContext(RoleContext);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const toggle = () => setModalOpen(!modalOpen);
  
  useEffect(() => {
    if (isKurir && !selectedKurir) {
      const savedKurirString = localStorage.getItem("selectedKurir");
      
      if (savedKurirString) {
        try {
          const savedKurir = JSON.parse(savedKurirString);
          setLocalKurir(savedKurir);
        } catch (error) {
          console.error("Error parsing saved kurir:", error);
        }
      }
    } else if (selectedKurir) {
      setLocalKurir(selectedKurir);
    }
  }, [selectedKurir, isKurir]);

  useEffect(() => {
    if (localKurir || !isKurir) {
      refreshTandaTerima();
    }
  }, [localKurir]);

  const refreshTandaTerima = async () => {
    setPending(true);

    try {
      if (isKurir && localKurir) {
        tandaTerimaAPI.getTandaTerimaKurir(localKurir.nama)
          .then((res) => {
            setTandaTerimaList(res.data);
          })
          .catch((error) => {
            console.error("Error fetching tanda terima for kurir:", error);
          })
          .finally(() => {
            setPending(false);
          });
      } else {
        tandaTerimaAPI.getTandaTerima()
          .then((res) => {
            setTandaTerimaList(res.data);
          })
          .catch((error) => {
            console.error("Error fetching tanda terima:", error);
          })
          .finally(() => {
            setPending(false);
          });
      }
    } catch (error) {
      console.error("Error refreshing tanda terima:", error);
      setPending(false);
    }
  };

  const filterTandaTerima = (items) => {
    const searchCategories = [
      "id",
      "nomor_surat",
      "perihal",
      "created_by",
      "unit_kerja",
      "date_created",
      "status",
    ];
    const filteredItems = items.filter(
      filterSearch(searchCategories, filterText)
    );

    return filteredItems;
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const renderKurirInfo = () => {
    if (isKurir && localKurir) {
      return (
        <Row className="mb-3 align-items-center">
          <Col>
            <h6 className="mb-0">User: <strong>{localKurir.nama}</strong></h6>
          </Col>
          <Col className="d-flex justify-content-end">
            <Button color="secondary" size="sm" onClick={onResetKurir}>
              Ganti User
            </Button>
          </Col>
        </Row>
      );
    }
    return null;
  };

  return (
    <FeatureContainer
      title={"Tanda Terima"}
      createButton={
        checkPermission(PERMISSIONS.ADD_TANDA_TERIMA) && !isKurir && (
          <CreateButton toggle={toggle}>Tambah Tanda Terima</CreateButton>
        )
      }
    >
      {renderKurirInfo()}
      
      <DataTable
        columns={TandaTerimaColumns(refreshTandaTerima)}
        data={filterTandaTerima(tandaTerimaList)}
        pagination
        selectableRowsHighlight
        highlightOnHover
        subHeader
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        persistTableHead
        progressPending={pending}
        theme={themeContext}
      />
      {!isKurir && (
        <ModalTambahTandaTerima
          create={true}
          resetState={refreshTandaTerima}
          toggle={toggle}
          isOpen={modalOpen}
        />
      )}
    </FeatureContainer>
  );
};

export default TandaTerimaContain;